import { render, staticRenderFns } from "./assign.vue?vue&type=template&id=1d9499ab&scoped=true"
import script from "./assign.vue?vue&type=script&lang=js"
export * from "./assign.vue?vue&type=script&lang=js"
import style0 from "./assign.vue?vue&type=style&index=0&id=1d9499ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9499ab",
  null
  
)

export default component.exports